export default __webpack_public_path__ + "static/media/img-egt-du3@3x.892518f5.png";